/**
 * Token de invitación durante la activación (T033; wiring §8.7).
 *
 * Vive en `sessionStorage` y **nunca** en `localStorage`: así muere al cerrar la pestaña y no queda
 * en el disco del teléfono. El token es un secreto: no se loguea, no se muestra en pantalla (salvo
 * como parte del enlace copiable en escritorio) y se borra en cuanto el dispositivo queda enrolado.
 *
 * Lo escribe `/activar/{token}` (y `/codigo` con el token rotado que devuelve `redeem-code`); lo
 * leen `/instalar` y `/registrar`; lo borra `/registrar` tras un enroll exitoso.
 */
export const ACTIVATION_TOKEN_STORAGE_KEY = 'fermin:activation-token';

/** Token guardado, o `null` si no hay activación en curso (o no hay almacenamiento). */
export function getActivationToken(): string | null {
  try {
    return globalThis.sessionStorage?.getItem(ACTIVATION_TOKEN_STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
}

export function setActivationToken(token: string): void {
  try {
    globalThis.sessionStorage?.setItem(ACTIVATION_TOKEN_STORAGE_KEY, token);
  } catch {
    // Modo privado estricto: el flujo sigue en memoria mientras no se recargue la pantalla.
  }
}

export function clearActivationToken(): void {
  try {
    globalThis.sessionStorage?.removeItem(ACTIVATION_TOKEN_STORAGE_KEY);
  } catch {
    // Sin almacenamiento no hay nada que borrar.
  }
}
